import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, StatusDot, formatNumberRu } from '@wit-support/ui';
const _bridge = [
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
];
void _bridge;
/** Источник сигнала. Имя провайдера, а не перевод. */
export const RISK_SOURCE_RU = {
    chargeblast: 'Chargeblast',
};
/** Тип алерта. */
export const RISK_ALERT_KIND_RU = {
    fraud: 'Фрод',
    dispute: 'Диспут',
    rdr: 'RDR',
    cancel: 'Отмена',
    info: 'Информационный',
    unknown: 'Не определён',
};
/**
 * Сеть/провайдер, приславший сигнал. Имена сетей не переводятся — оператор
 * знает их ровно в таком виде; поясняется только схема, стоящая за
 * аббревиатурой.
 */
export const RISK_NETWORK_RU = {
    Ethoca: 'Ethoca',
    CDRN: 'CDRN',
    RDR: 'RDR (Visa)',
    Discover: 'Discover',
    AMEX: 'AMEX',
    JCB: 'JCB',
    Cancel: 'Отмена подписки',
    TC40: 'TC40 (Visa)',
    SAFE: 'SAFE (Mastercard)',
    PayPal: 'PayPal',
};
/** Наш статус кейса. */
export const RISK_CASE_STATUS_RU = {
    open: 'Открыт',
    actioned: 'Решение отправлено',
    resolved: 'Закрыт',
    dismissed: 'Отклонён',
};
/**
 * Статус аккаунта источника. Живёт здесь, рядом с остальными подписями
 * риск-домена, а не в `status-pill.tsx`: пилюля — лишь один из двух читателей,
 * второй — выпадающий список в форме правки аккаунта, и разъехавшись, они дали
 * бы одному и тому же значению два разных названия.
 */
export const RISK_ACCOUNT_STATUS_RU = {
    active: 'Активен',
    disabled: 'Отключён',
};
/**
 * Статус идентификации клиента. `unavailable` и `not_found` — РАЗНЫЕ факты и
 * подписаны по-разному: первое значит «спросить некого, эндпоинта нет»,
 * второе — «в биллинге такого клиента нет».
 */
export const RISK_IDENTIFICATION_STATUS_RU = {
    pending: 'Ожидает',
    resolved: 'Клиент определён',
    ambiguous: 'Несколько кандидатов',
    not_found: 'Клиент не найден',
    unavailable: 'Идентификация недоступна',
};
/**
 * Подпись `ambiguous` ЗАВИСИТ ОТ ЧИСЛА кандидатов, потому что один статус
 * покрывает три разных факта. На проде 407 из 459 кейсов в `ambiguous` имели
 * РОВНО ОДНОГО кандидата: неоднозначности там нет, есть требование
 * подтвердить — а подпись «Несколько кандидатов» была для них прямой
 * неправдой и заставляла оператора искать несуществующий выбор.
 *
 * Число известно не везде (список кейсов его не отдаёт), поэтому
 * `candidateCount` необязателен: без него берётся словарная подпись.
 */
const AMBIGUOUS_BY_COUNT_RU = {
    /** Матчер ответил, но ни одного кандидата не предложил. */
    none: 'Кандидаты не предложены',
    /** Кандидат один — выбирать не из чего, нужно подтвердить. */
    one: 'Требует подтверждения',
    /** Настоящая неоднозначность. */
    many: 'Несколько кандидатов',
};
export function riskIdentificationLabelRu(status, candidateCount) {
    if (status !== 'ambiguous' || candidateCount == null) {
        return RISK_IDENTIFICATION_STATUS_RU[status];
    }
    if (candidateCount <= 0)
        return AMBIGUOUS_BY_COUNT_RU.none;
    return candidateCount === 1 ? AMBIGUOUS_BY_COUNT_RU.one : AMBIGUOUS_BY_COUNT_RU.many;
}
/**
 * Класс дубликата. Разница не косметическая: `intra_source` значит, что за
 * алерт заплачено дважды и это заявляется провайдеру reason-кодом `Duplicate`,
 * а `cross_source` — что та же реальность видна в двух системах и платить
 * второй раз не за что.
 */
export const RISK_DUPLICATE_CLASS_RU = {
    intra_source: 'Дубликат внутри источника',
    cross_source: 'Дубликат между источниками',
    none: 'Первый алерт кейса',
};
/**
 * Чем кандидат (или его списание) совпал с алертом.
 *
 * Словарь НЕ `Record<…>` по перечислению, а поиск по строке: сигналы приходят
 * из чужого ответа и лежат в jsonb-снимке. Там встречается и легаси-имя
 * `card_last4`, и завтрашний сигнал апстрима, которого мы ещё не знаем, —
 * незнакомый показываем как есть, потому что машинный ключ перед оператором
 * честнее, чем пропуск или выдуманный перевод.
 */
const RISK_MATCH_SIGNAL_RU = {
    authCode: 'код авторизации',
    last4: 'последние 4 цифры карты',
    card_last4: 'последние 4 цифры карты',
    date: 'дата',
    amount: 'сумма',
    // Сильнейший из сигналов: идентификатор транзакции в сети глобально
    // уникален, и его совпадение — фактически доказательство, а не довод.
    networkId: 'ID транзакции в сети',
};
export function riskMatchSignalLabelRu(signal) {
    return RISK_MATCH_SIGNAL_RU[signal] ?? signal;
}
/**
 * Насколько платёжный сервис уверен в совпадении.
 *
 * Шкалу задаёт АПСТРИМ, мы её не пересчитываем и не переводим в проценты,
 * которых он не давал. Подписи самодостаточны — «Совпадение вероятное» читается
 * в строке кандидата без соседнего слова «уверенность», а «Уверенность: высокая»
 * без него не читается вовсе.
 *
 * `none` — это ОТВЕТ апстрима «ничего не сходится», а не «поля нет»: снимок
 * кандидата старше 2026-08-25 несёт `null`, и он не рисуется вовсе. Свести их в
 * одну подпись значит соврать про старые кейсы.
 */
export const RISK_MATCH_CONFIDENCE_RU = {
    confirmed: 'Совпадение подтверждено',
    high: 'Совпадение вероятное',
    medium: 'Совпадение возможное',
    low: 'Совпадение слабое',
    none: 'Совпадений нет',
};
/**
 * Вес убывает вместе с уверенностью: подтверждённое совпадение обязано быть
 * видно первым взглядом, слабое — не спорить за внимание с диспутом и
 * возвратом рядом.
 */
const CONFIDENCE_VARIANT = {
    confirmed: 'success',
    high: 'info',
    medium: 'neutral',
    low: 'neutral',
    none: 'neutral',
};
export const RiskMatchConfidenceBadge = ({ confidence, size = 'sm', className, }) => {
    if (confidence === null)
        return null;
    return (_jsx(Badge, { variant: CONFIDENCE_VARIANT[confidence], size: size, className: className, children: RISK_MATCH_CONFIDENCE_RU[confidence] }));
};
RiskMatchConfidenceBadge.displayName = 'RiskMatchConfidenceBadge';
/**
 * Правило, по которому клиент привязался к кейсу БЕЗ человека.
 *
 * Подписи — продолжение фразы «привязано автоматически, …», поэтому со строчной
 * буквы и в творительном смысле «по чему».
 *
 * `single-customer` — НАШЕ правило, и оно намеренно звучит иначе, чем четыре
 * калиброванных правила платёжного сервиса: там апстрим указал конкретное
 * списание, здесь он этого не смог, но все предложенные кандидаты оказались
 * одним и тем же человеком. Кейс привязывает ЧЕЛОВЕКА, поэтому для нас такой
 * ответ решающий; выдать его за калиброванное правило апстрима нельзя.
 *
 * `code+amount` — четвёртый серверный путь (редакция контракта поиска от
 * 2026-08-27): код авторизации + ТОЧНАЯ сумма в окне сеттлмента, карта в этом
 * пути игнорируется намеренно (см. докблок `RiskAutoLinkBasis` в
 * `@wit-support/risk-alerts`).
 */
export const RISK_AUTO_LINK_BASIS_RU = {
    'network-id': 'по ID транзакции в сети',
    'code+card': 'по коду авторизации и карте',
    'code+token': 'по коду авторизации и токену карты',
    'code+amount': 'по коду авторизации и сумме',
    'single-customer': 'все кандидаты оказались одним клиентом',
};
export function riskAutoLinkBasisLabelRu(basis) {
    return RISK_AUTO_LINK_BASIS_RU[basis];
}
/**
 * Как совпал код авторизации. Возвращает подпись ТОЛЬКО для `zero-padded`:
 * `exact` — обычное совпадение, и плашка на каждой строке была бы шумом, а вот
 * восстановленный ведущий ноль обязан быть назван вслух. Провайдеры их
 * обрезают (`26044` = `026044`), четверть кодов в зеркале платёжного сервиса
 * начинается с нуля, и без пометки оператор отвергает ПРАВИЛЬНОГО кандидата за
 * «коды же разные».
 */
export function riskAuthCodeMatchLabelRu(match) {
    return match === 'zero-padded' ? 'Код: восстановлены нули' : null;
}
/**
 * Как совпала ДАТА списания.
 *
 * Подпись есть у ОБОИХ значений, и это не симметрия ради симметрии. Раньше
 * `exact` не подписывался вовсе, и разница читалась только по ОТСУТСТВИЮ
 * плашки — а отсутствие плашки неотличимо от «поля нет» и от «дату вообще не
 * сверяли». На боевой паре кандидатов (одни последние четыре цифры, оба Apple
 * Pay, разные люди) точный день против соседнего — один из трёх фактов,
 * которые их вообще различают, и предлагать оператору вычитать его из пустоты
 * нельзя.
 *
 * Вес при этом РАЗНЫЙ: соседний день — оговорка (плашка), точный — норма
 * (тихая подпись без оформления). `near` значит допуск на часовые пояса и
 * полночь при списании, а не совпадение.
 */
export function riskDateMatchLabelRu(match) {
    if (match === null)
        return null;
    return match === 'near'
        ? { label: 'Соседний день', variant: 'warning' }
        : { label: 'день в день', variant: null };
}
/**
 * Состояние самого списания у платёжного сервиса.
 *
 * `succeeded` подписи НЕ получает — это норма, и плашка на каждой строке
 * утопила бы две, ради которых поле показывается вовсе. Незнакомое значение
 * показываем КАК ЕСТЬ: набор статусов принадлежит Stripe, и машинный ключ
 * перед оператором честнее выдуманного перевода.
 *
 * Различие решающее, а не косметическое: фрод-алерт регулярно ссылается на
 * авторизацию, записанную как `failed` — код авторизации у попытки есть, деньги
 * не двигались. На проде такая пара (`failed`-попытка и `succeeded`-списание на
 * одних и тех же последних четырёх цифрах) пришла в одном ответе, причём
 * `failed` шла в выдаче ПЕРВОЙ.
 */
export function riskChargeStatusLabelRu(status) {
    if (status === null || status === 'succeeded')
        return null;
    if (status === 'failed')
        return { label: 'Списание не прошло', variant: 'danger' };
    if (status === 'pending')
        return { label: 'Списание в обработке', variant: 'warning' };
    return { label: `Статус списания: ${status}`, variant: 'neutral' };
}
/**
 * Форматирование дробных величин апстрима под ru-локаль: `2.874` → `2,9`.
 * `formatNumberRu` кита, а не `toFixed`, потому что `toFixed` печатает точку —
 * рядом с денежными суммами из `formatMoney`, где разделитель запятая, это
 * выглядит как данные из другой системы.
 */
function ruNumber(v, maximumFractionDigits) {
    return formatNumberRu(v, { maximumFractionDigits });
}
/**
 * Почему сумма списания расходится с суммой алерта — ответ на самый частый
 * вопрос оператора о кандидате («алерт говорит 139.38, списание 143.42 — это
 * те же деньги?»).
 *
 * `exact` подписи НЕ получает: совпавшая сумма — норма, и плашка «сумма
 * совпала» на каждой строке утопила бы три случая, ради которых всё это
 * показывается. `null` — поля в снимке нет; молчим, а не выдумываем вердикт.
 *
 * `variant` едет вместе с подписью: расхождение объяснимое (комиссия, курс) и
 * расхождение необъяснимое — разные факты, и оператор обязан различать их не
 * вчитываясь.
 */
export function riskAmountMatchLabelRu(match) {
    if (match === null)
        return null;
    switch (match.kind) {
        case 'exact':
            return null;
        case 'fee-markup':
            return {
                label: match.markupPct != null
                    ? `Комиссия эмитента +${ruNumber(match.markupPct, 1)}%`
                    : 'Комиссия эмитента',
                variant: 'neutral',
            };
        case 'fx-plausible':
            return {
                label: match.impliedRate != null
                    ? `Валюта карты, курс ${ruNumber(match.impliedRate, 4)}`
                    : 'Валюта карты',
                variant: 'neutral',
            };
        case 'unknown-currency':
            return { label: 'Валюты несравнимы', variant: 'neutral' };
        case 'mismatch':
            return { label: 'Сумма не совпала', variant: 'warning' };
    }
}
/** Ключ, по которому алерт приклеился к кейсу. */
export const RISK_CORRELATION_BASIS_RU = {
    external_order: 'По номеру заказа',
    arn: 'По ARN',
    network_id: 'По id транзакции в сети',
    fuzzy: 'По эвристике (код авторизации + карта + сумма)',
    none: 'Без совпадения',
};
export function riskCorrelationBasisLabelRu(v) {
    return RISK_CORRELATION_BASIS_RU[v];
}
/**
 * Списки значений для `Select`-фильтров. Выведены из словарей, а не написаны
 * вторым списком: иначе фильтр и подписи разъезжаются молча.
 */
export const RISK_SOURCES = Object.keys(RISK_SOURCE_RU);
export const RISK_ALERT_KINDS = Object.keys(RISK_ALERT_KIND_RU);
export const RISK_NETWORKS = Object.keys(RISK_NETWORK_RU);
export const RISK_IDENTIFICATION_STATUSES = Object.keys(RISK_IDENTIFICATION_STATUS_RU);
/**
 * Порядок здесь — порядок в словаре выше, и он же порядок ЖИЗНЕННОГО ЦИКЛА
 * кейса (не разобран → решение отправлено → закрыт → отклонён). Оператор
 * читает выпадающий список сверху вниз, и алфавитный порядок заставлял бы его
 * искать «Открыт» между «Отклонён» и «Решение отправлено».
 */
export const RISK_CASE_STATUSES = Object.keys(RISK_CASE_STATUS_RU);
const KIND_VARIANT = {
    fraud: 'danger',
    dispute: 'danger',
    rdr: 'warning',
    cancel: 'warning',
    info: 'neutral',
    unknown: 'neutral',
};
/**
 * Статус кейса — ЖИЗНЕННЫЙ ЦИКЛ сущности, а не классификатор, поэтому он
 * говорит на языке `StatusPill`: нейтральная пилюля с цветной точкой (см.
 * `status-pill.tsx`, `kind="conversation"`). Сплошная цветная заливка в
 * админке зарезервирована за классификаторами (тип алерта, сеть, дубликат) —
 * четыре разноцветных плашки на статус диалога кричали бы громче самого текста
 * и ставили бы «Открыт» в один ряд с «Фрод».
 *
 * Разметка повторяет `StatusPill` намеренно, а не переиспользует его: пилюля
 * читает подписи из своих словарей, и импорт `RISK_CASE_STATUS_RU` отсюда
 * замкнул бы `status-pill` ↔ `risk-labels` в цикл модулей.
 */
const CASE_STATUS_DOT = {
    open: 'blue',
    actioned: 'amber',
    resolved: 'green',
    dismissed: 'slate',
};
const IDENTIFICATION_VARIANT = {
    pending: 'neutral',
    resolved: 'success',
    ambiguous: 'warning',
    not_found: 'danger',
    unavailable: 'neutral',
};
const DUPLICATE_VARIANT = {
    intra_source: 'warning',
    cross_source: 'info',
    none: 'neutral',
};
export const RiskSourceBadge = ({ source, size = 'sm', className }) => (_jsx(Badge, { variant: "neutral", size: size, className: className, children: RISK_SOURCE_RU[source] }));
RiskSourceBadge.displayName = 'RiskSourceBadge';
export const RiskKindBadge = ({ kind, size = 'sm', className }) => (_jsx(Badge, { variant: KIND_VARIANT[kind], size: size, className: className, children: RISK_ALERT_KIND_RU[kind] }));
RiskKindBadge.displayName = 'RiskKindBadge';
/** `null` не рисует пустой бейдж: сеть в сигнале необязательна. */
export const RiskNetworkBadge = ({ network, size = 'sm', className }) => {
    if (network === null)
        return null;
    return (_jsx(Badge, { variant: "neutral", size: size, className: className, children: RISK_NETWORK_RU[network] }));
};
RiskNetworkBadge.displayName = 'RiskNetworkBadge';
export const RiskCaseStatusBadge = ({ status, size = 'sm', className, }) => (_jsxs(Badge, { variant: "neutral", size: size, className: className, children: [_jsx(StatusDot, { variant: CASE_STATUS_DOT[status], "aria-hidden": "true" }), _jsx("span", { children: RISK_CASE_STATUS_RU[status] })] }));
RiskCaseStatusBadge.displayName = 'RiskCaseStatusBadge';
export const RiskIdentificationBadge = ({ status, candidateCount, size = 'sm', className, }) => (_jsx(Badge, { variant: IDENTIFICATION_VARIANT[status], size: size, className: className, children: riskIdentificationLabelRu(status, candidateCount) }));
RiskIdentificationBadge.displayName = 'RiskIdentificationBadge';
/**
 * Рендерится только для настоящего дубликата: `none` — это «первый алерт
 * кейса», то есть подавляющее большинство строк, и бейдж на каждой из них был
 * бы шумом (тот же приём, что у `SenderCapacityBadge`).
 */
export const RiskDuplicateBadge = ({ duplicateClass, size = 'sm', className, }) => {
    if (duplicateClass === 'none')
        return null;
    return (_jsx(Badge, { variant: DUPLICATE_VARIANT[duplicateClass], size: size, className: className, children: RISK_DUPLICATE_CLASS_RU[duplicateClass] }));
};
RiskDuplicateBadge.displayName = 'RiskDuplicateBadge';
//# sourceMappingURL=risk-labels.js.map